"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useToast = exports.ToastProvider = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _Toast = _interopRequireDefault(require("./Toast"));
var _messages = require("./messages");
var _getLanguage = _interopRequireDefault(require("../utils/getLanguage"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const ToastContext = /*#__PURE__*/_react.default.createContext();
const useToast = () => _react.default.useContext(ToastContext);

/**
 * Provides a context for managing toasts.
 * @param {Object} props - The component props.
 * @param {ReactNode} props.children - The child components.
 * @returns {JSX.Element} The toast provider component.
 */
exports.useToast = useToast;
const ToastProvider = _ref => {
  let {
    children
  } = _ref;
  const language = (0, _getLanguage.default)();
  const [toasts, setToasts] = _react.default.useState([]);

  /**
   * Removes a toast from the list of toasts.
   * @param {string} id - The ID of the toast to remove.
   */
  const removeToast = _react.default.useCallback(id => {
    setToasts(currentToasts => currentToasts.map(toast => toast.id === id ? _objectSpread(_objectSpread({}, toast), {}, {
      isVisible: false
    }) : toast));
    setTimeout(() => {
      setToasts(currentToasts => currentToasts.filter(toast => toast.id !== id));
    }, 500); // Adjust this duration if needed
  }, []);

  /**
   * Adds a new toast to the list of toasts.
   * @param {string} message - The message to display in the toast.
   * @param {Object} options - The options for the toast.
   * @param {string} [options.position='bottom'] - The position of the toast (e.g., 'top', 'bottom').
   * @param {ReactNode} [options.icon=null] - The icon to display in the toast.
   * @param {number} [options.duration=3000] - The duration in milliseconds for which the toast should be visible.
   * @param {boolean} [options.dismissable=true] - Whether the toast can be dismissed by the user.
   */
  const addToast = _react.default.useCallback(function (message) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const {
      position = "bottom",
      icon = null,
      duration = 3000,
      dismissable = true
    } = options;
    const id = Math.random().toString(36).substring(2, 11);

    // Clear existing toasts before adding a new one
    setToasts([]);
    setToasts(currentToasts => [...currentToasts, {
      id,
      message,
      icon,
      position,
      isVisible: true,
      dismissable
    }]);
    setTimeout(() => removeToast(id), duration);
  }, [removeToast]);
  return /*#__PURE__*/_react.default.createElement(ToastContext.Provider, {
    value: {
      addToast
    }
  }, children, /*#__PURE__*/_react.default.createElement("div", {
    role: "region",
    "aria-label": "".concat(_messages.messages[language], " (F8)"),
    tabIndex: "-1"
  }, toasts.map(toast => /*#__PURE__*/_reactDom.default.createPortal(/*#__PURE__*/_react.default.createElement(_Toast.default, {
    key: toast.id,
    message: toast.message,
    position: toast.position,
    icon: toast.icon,
    isVisible: toast.isVisible,
    dismissable: toast.dismissable,
    onDismiss: () => removeToast(toast.id) // Pass onDismiss here
  }), document.body))));
};
exports.ToastProvider = ToastProvider;